define('plugin/promotion/controller/PromotionController',['require','lib/controller/BaseController','plugin/promotion/view/PromotionIndexView','plugin/promotion/view/PromotionClientInstanceListView','plugin/promotion/collection/PromotionInstanceCollection','plugin/promotion/model/PromotionOrderModel','controller/sub/ClientSubController','Config'],function (require) {

    var BaseController = require('lib/controller/BaseController');

    var PromotionIndexView = require('plugin/promotion/view/PromotionIndexView');
    var PromotionClientInstanceListView = require('plugin/promotion/view/PromotionClientInstanceListView');

    var PromotionInstanceCollection = require('plugin/promotion/collection/PromotionInstanceCollection');
    var PromotionOrderModel = require('plugin/promotion/model/PromotionOrderModel');

    var ClientSubController = require('controller/sub/ClientSubController');

    var Config = require('Config');

    /**
     * Promotion Controller
     *
     * @class PromotionController
     */
    return BaseController.extend({

        _collection: null,
        _message: null,

        _clientConstroller: null,

        initialize: function () {
            this._collection = this.getOption('collection');
            var messagesClientLoginChannel = Backbone.Wreqr.radio.channel('client_login');

            messagesClientLoginChannel.vent.on('client:signin', _.bind(function () {
                if(this._collection && this._collection.length){
                    this._collection.fetch({reset: true});
                }
            }, this));
            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of gift cards
         *
         * @param services
         */
        index: function (services) {
            this._view = new PromotionIndexView({
                collection: this._collection
            });

            this.getMainLayout().getContentRegion().show(this._view);

            if (this._message) {
                this.showErrorMessage(this._message);
                this._message = null;
            }

            this._collection.getPager().setSkipPagination(true);
            this._collection.load();
        },

        buyWithClientInfo: function (id) {
            if (Config.getInstance().getPluginStatus('client_login')) {
                this.buy(id);
            } else {
                this.showClientInfo(id);
            }
        },

        buyWithClientInfoByBonus: function (id) {
            if (Config.getInstance().getPluginStatus('client_login')) {
                this.buyByBonus(id);
            } else {
                this.showClientInfo(id);
            }
        },


        buyByBonus: function (id) {
            var model = new PromotionOrderModel({
                promotion_id: id,
                bonus: true,
            });

            model.save(null, {
                success: _.bind(function (model) {
                    if (model.get('bonus')) {
                        this._redirectWithReplace('bonus/pay/' + model.get('bonus')['id']);
                    }
                }, this),
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        if (Config.getInstance().getPluginStatus('client_login')) {
                            this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('gift-card/buy/' + id + '/bonus'));
                        } else {
                            this.showClientInfo(id);
                        }
                    } else {
                        this.showErrorMessage(result.error);
                    }
                }, this)
            });
        },

        /**
         * Creates gift card order and redirect to payment or to sign up client.
         *
         * @param id
         */
        buy: function (id) {
            var model = new PromotionOrderModel({
                promotion_id: id
            });
            model.save(null, {
                success: _.bind(function (model) {
                    if (model.get('invoice')) {
                        this._redirectWithReplace('invoice/pay/' + model.get('invoice').get('id'));
                    }
                }, this),
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        if (Config.getInstance().getPluginStatus('client_login')) {
                            this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('gift-card/buy/' + id));
                        } else {
                            this.showClientInfo(id);
                        }
                    } else {
                        this.showErrorMessage(result.error);
                    }
                }, this)
            });
        },

        /**
         * Displays clients gift cards
         */
        my: function (id) {
            var collection = new PromotionInstanceCollection();

            var view = new PromotionClientInstanceListView({
                collection: collection,
                highlighted: id
            });

            this.getMainLayout().getContentRegion().show(view);

            collection.getPager().setSkipPagination(true);
            collection.load({
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('gift-card/my'));
                    }
                }, this)
            });
        },

        /**
         * Just to allow old style links
         *
         * @param id
         * @param code
         */
        view: function (id, code) {
            window.location.replace('/v2/ext/promotion/print/id/' + id + '/print/1/code/' + code);
        },

        showClientInfo: function (id) {
            this._selectedGiftCardId = id;

            this.getMainLayout().getContentRegion().show(
                this.getClientController().createView()
            );
        },

        getClientController: function () {
            if (!this._clientConstroller) {
                this._clientConstroller = new ClientSubController({
                    clientModel: this.getOption('clientModel'),
                    app: this.getOption('app'),
                    formTitle: 'promotion_client_info_form_title',
                    formSubTitle: 'promotion_client_info_form_sub_title',
                    backButtonLabel: 'back',
                    backButtonLink: '#gift-card',
                    submitButtonLabel: 'continue'
                });
                this.listenTo(this._clientConstroller, 'client:saved', _.bind(function () {
                    this.buy(this._selectedGiftCardId);
                }, this));
            }
            return this._clientConstroller;
        },

        /**
         * Shows error message
         *
         * @param String error
         */
        showErrorMessage: function (error) {
            this._message = error;
            this._redirect('gift-card');
        }

    });

});
